export enum UserActions {
  SET_USER = 'u0',
  OPEN_ACCOUNT = 'u1',
  LOGOUT = 'u2'
}
